import React, {Fragment, useRef, useState} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import moment from "moment";
import DataGrid from "./DataGrid";
import StringToJSX from "../functions/StringToJsx";


const MessageExchangeGrid = (_props) => {
  const {isAuthenticated} = useAuth0();
  const props = {
    ..._props
  }
  const [state, setState] = useState({
    canEdit: props.canEdit||false,
  });

  const messages = props.messages;
  const dataGridRef = useRef();

  const renderMessage = (params) => {
    if (params.data.additionalInfo && params.data.additionalInfo !== "") {
      const htmlString = "<div style='white-space: pre-wrap'>" + params.data.additionalInfo + "</div>";
      return(<StringToJSX domString={htmlString}/>);
    }

    else
      return "";

    const messageParts = params.data.message.split("\n");
    return (
      <div style={{lineHeight: 1, fontSize:"12px", fontFamily: "monospace" }}>
        { messageParts.map((part, i) => { return <div key={i} ><span>{part}</span><br/></div>}) }
      </div>
    )
  }

  const getColumns = (props) => {
    const baseColumn = {
      options: {
        cellStyle: { fontSize:14 },
      },
      editable: props.canEdit,
      suppressMenu: true,
      suppressNavigable: true
    };

    return [
      {
        ...baseColumn,
        headerName: "Time Stamp",
        field: "messageDate",
        width: 160,
        valueFormatter: (params)=> {
          return params.value ? moment.utc(params.value).format("DD/MM/YYYY HH:mm") : "";
        }
      },
      {
        ...baseColumn,
        headerName: "Exchange",
        field: "action",
        width: 100,
        autoHeight: true,
        wrapText: true,
      },
      {
        ...baseColumn,
        headerName: "Order Status",
        field: "status",
        width: 150,
        autoHeight: true,
        wrapText: true
      },
      {
        ...baseColumn,
        headerName: "Additional Information",
        field: "additionalInfo",
        flex: 1,
        autoHeight: true,
        wrapText: true,
        cellRenderer: {
          component: "renderMessage",
        },
      },
    ];
  };

  const dataGridComponents = {renderMessage};

  return (isAuthenticated &&
    <div style={{width: props.width?props.width:"100%", ...props.style}}>
      <DataGrid
        title="MessageExchangeGrid"
        ref={dataGridRef}
        columns={getColumns({canEdit: state.canEdit})}
        rows={messages}
        height={props.height||"300px"}
        components={dataGridComponents}
        options={{
          singleClickEdit: true,
          editType:'fullRow',
          onCellValueChanged: ()=>{}, //prevent default onCellValueChanged
          defaultColDef: {
            editable: false,
            resizable: false,
          }
        }}
      />
    </div>
  );

}

export default MessageExchangeGrid;
